import React from "react";
import Header from "../../components/Header/Header";
import Hero from "../../components/Hero/Hero";
import HeroV2 from "../../components/HeroV2/HeroV2";
import HeroV3 from "../../components/HeroV3/HeroV3";
import Footer from "../../components/Footer/Footer";
import OurProducts from "../../components/OurProducts/OurProducts";
import { Helmet } from "react-helmet-async";
function Home() {
  return (
    <>
      <Helmet>
        <title>
          Avvoka | Exporters of Fresh Produce, Tea & Coffee from Kenya
        </title>
        <meta
          name="description"
          content="Avvoka exports premium fresh fruits, vegetables, Kenyan tea, and coffee to global markets. Trusted export partner committed to freshness, quality, and sustainability."
        />
        <meta
          name="keywords"
          content="Avvoka, fresh produce export, Kenyan fruits, vegetables, avocado export, mango export, passion fruit, Kenyan tea, Kenyan coffee, global trade, export company"
        />
        <meta
          property="og:title"
          content="Avvoka | Exporters of Fresh Produce, Tea & Coffee from Kenya"
        />
        <meta
          property="og:description"
          content="Delivering Kenya’s finest fresh produce, tea, and coffee to international markets. Quality, freshness, and sustainability guaranteed."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://avvoka.co.ke" />
        <meta
          property="og:image"
          content="https://avvoka.co.ke/assets/images/og-image.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@AvvokaExports" />
        <meta
          name="theme-color"
          content="#4CAF50"
          media="(prefers-color-scheme: light)"
        />
        <meta
          name="theme-color"
          content="#2E7D32"
          media="(prefers-color-scheme: dark)"
        />
      </Helmet>

      <Header />
      <HeroV3 />
      <OurProducts />
      <Footer />
    </>
  );
}

export default Home;
